import { render } from "./LogIn.vue?vue&type=template&id=6a9aac66"
import script from "./LogIn.vue?vue&type=script&lang=ts"
export * from "./LogIn.vue?vue&type=script&lang=ts"
script.render = render

export default script